export const featuresMap = {
  newColorsBranding: 'newColorsBranding',
};
